import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-2">
			La kapvortojn oni povus skribi ankaŭ en citiloj. Ĝuste tiel nomiĝis famaj siatempe tendaroj en Estonio en 70-80-j jaroj. 
			Ilin partoprenis sufiĉa kvanto da personoj (iam eĉ pli, ol nunajn SEJT-ojn), kiuj ĝuis surnaturajn ekskursojn.
		</p>
		
		<p class="mb-2">
			En eks-Sovetunio nun, kiel mi scias, ne ekzistas io simila (krom unu escepto, pri kiu mi diros poste). 
			Sed eksterlande sufiĉe multas diversaj prinaturaj aranĝoj: en Poprad (ĉu daŭros post la forpaso de M. Zvara?), en Gresillon, en Kvinpetalo, en Jetrzichovice kaj en aliuj lokoj.
		</p>
		
		<p class="mb-5">
			Tien venas homoj, kiuj kun plezuro pasigas la tempon  surnature. 
			Sed, se diri ĝenerale, ĉu esperantistoj ŝatas naturon?
		</p>
		
		<p class="mb-2">
			Ekzistas multaj, eĉ multegaj klasifikoj de homoj. Oni povas dividi ilin je konsumantoj kaj produktantoj, introvertitoj kaj ekstravertitoj, dikuloj kaj magruloj ktp.
		</p>
		
		<p class="mb-2">
			Kaj ekzistas ankoraŭ unu divido: je homoj de kulturo kaj homoj de naturo.
		</p>
		
		<p class="mb-2">
			La unuaj perceptas la mondon ne en ĝiaj realaj fenomenoj, sed en vortoj, kiuj korespondas al tiuj fenomenoj. Laŭ difino de la akademiano I. P. Pavlov, ĉe ili absolute dominas la dua signalsistemo – la parola sistemo.
		</p>
		
		<p class="mb-2">
			Fakte, ĝuste pro la ekzisto de tiu sistemo homoj diferenciĝas de bestoj. 
			Se akcepti la teorion, ke en profunda senco la lingvo estas la bazo de konscio, do nur tion, kion ni nomis, kio estas donita al ni en la lingvo, ni povas percepti, ekkoni. 
			Ekzemple, nun aperis multaj novaj malsanoj, kiel «sindromo de konstanta laceco», «sindromo de needukema infano», aŭtismo ktp. 
			Antaŭnelonge oni ne difinis tion kiel specialaj apartaj malsanoj, kaj do ili por ni ne ekzistis kaj neniu penis kuraci ilin kiel tiajn.
		</p>
		
		<p class="mb-2">
			Do, la «doto de parolo» estas, certe, la bazo de homa kulturo. 
			Kaj estas klare, ke esperantistoj plejparte emas al vorta kulturo, ĉar Esperanto, kiun ili elektis kiel sian flank- aŭ eĉ ĉef-okupon, estas unuavice LINGVO. 
			Kaj en tiu speciala lingvo dominas ĝuste sistemeco kaj reguleco, tiel mankaj en natura ĉiutaga vivo. «Homoj de kulturo» kreas sian propran mondon de kulturo; eble pro tio, ke la natura mondo ne kontentigas ilin?
		</p>
		
		<p class="mb-5">
			Sed ĉu ne trolimigita estas la vivo de «homo de kulturo»? 
			Ĉu ne vivas li en tiu medio, kiun angla poeto S. Coleridge nomis «la-viva- eĉ-en-la-morto», kaj priskribis kiel la plej teruran sur la Tero, la senhome teruran? 
			La vorto ne povas morti, ĉar ĝi ne estas viva: ĝi estas alia realeco ol la vivo, la «neviva-nemorta». 
			Tiu realeco estas parto, alta spirita paro de homa vivo; sed ja ne tuta la vivo! 
			Kiam ĝi fariĝas la tuta vivo, tio danĝeras por normala, ĉiuflanka disvolviteco de homo.
		</p>
		
		<p class="mb-2">
			Mi multfoje renkontiĝis kun tia sinteno: kiam al organizataj de nia klubo prinaturaj renkontiĝoj venas po 2-3, aŭ tute neniuj personoj; 
			kiam dum montrado de prinatura filmo en Esperanto dum UK (en la Libroservo, en regno de kulturo!) aŭdiĝas indignaj ekkrioj: «Kion tio signifas? Kiu permesis TION montri?» ktp.
		</p>
		
		<p class="mb-2">
			Sed la lasta guto evidentiĝis ĵus okazinta okazo dum la preparado de la teksto por nova prinatura filmo, kiun kreas nia klubo kunlabore kun Nacia Ekologia Centro de Ukrainio kaj unu esperantista mecenato. 
			Kompreneble, la filmo estas en Esperanto, kaj mi serĉis iun belan prinaturan poemon, originale verkitan en nia kara lingvo. 
			La traserĉitaj de mi verkoj klare dividiĝas je du partoj: socialaj, politikaj, priesperantaj – specialaĵo de nia poezio; kaj amaj poemoj – komuna temo por la tuta homaro. 
			Prinaturaj originalaj verkoj tute mankis!
		</p>
		
		<p class="mb-2">
			Mi ĝojos, se mi eraris, kaj tiu konkludo aperis nur pro mia limigita scio de nia originala literaturo. 
			Mi petas spertulojn informi min (kaj la mondon!) pri eventualaj trovaĵoj.
		</p>
		
		<p class="mb-2">
			Sed tiu evento instigis min rimarki la tendencon, kiu ŝajnas nekontestebla kaj klara. 
			Tiu tendenco ne estas sana en vivanta… kaj movado, kaj des pli komunumo. 
			Male, ĝi montras iun «mort-emon» de nia evoluo.
		</p>
		
		<p class="mb-2">
			Mi tre volus esti alikonvinkita pri mia dolora konkludo.
		</p>
	
	`
	)
}

const itemName = {
	esp: 'Esperanto kaj naturo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;
